import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            精彩剧集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            高清画质流畅播放，热播影视一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { const t = e.currentTarget; const p = t.parentElement; if (p) p.style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                  <span className="text-xs text-white font-medium px-2 py-0.5 rounded bg-black/40 whitespace-nowrap">
                    {item.duration}
                  </span>
                  <div className="w-8 h-8 rounded-full bg-primary-500/90 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-sm"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">
                  {item.category}
                </p>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}